// eslint-ignore
export default 
`<Toggle v-model="value" left-label="Left Label"/>
<Toggle v-model="value" right-label="Right Label"/>


export default {
  components: { Toggle },
  
  data() {
    return { 
      value: false
    }
  }
}`;